import { useEffect, useRef } from 'react';

import { HEADER_HEIGHT } from '../constants/base-elements-sizes';
import { ELEMENTS_IDS } from '../constants/elements-ids';

export function useGetHeaderHeight(): number {
  const headerRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    const header = document.getElementById(ELEMENTS_IDS.headerId);

    if (header) {
      headerRef.current = header;
    }
  }, []);

  return headerRef.current?.getBoundingClientRect().height || HEADER_HEIGHT;
}
